import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/tags")({
  // Component moved to $orgSlug.admin.tags.lazy.tsx for code splitting
});
